define('modules/files/files_list_view',[
  'backbone',
  'jquery',
  '_',

  './files_view',

  './file_list_item_view',
  'text!./files_header_template.html'
], function (Backbone, $, _,
             FilesView,
             FileItemView,
             files_header_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {

      _.extend(this, opts);
      this.subViews = [];

      this.files = new FilesView();
      this.subViews.push(this.files);

      this.collection = this.files.collection;
      if (this.limit) {
        this.collection.params = _.extend(this.collection.params, {limit: this.limit});
      }

      if(this.filter_id) {
        this.collection.params = _.extend(this.collection.params, {filter_id: this.filter_id});
      }

      if (this.location_id) {
        this.collection.params = _.extend(this.collection.params, {location_id: this.location_id});
      }

      this.listenTo(this.collection, 'sync', function (collection) {
        this.renderHeader();
        this.renderList();
        this.files.renderPagination();
      }, this);

      this.render();

      this.collection.fetch();
    },

    hasSidebar: false,
    subViews: [],
    className: 'file-list-container',

    header_template: _.template(files_header_template),

    events: {},

    render: function () {
      this.$el = this.files.$el;
      return this;
    },

    renderHeader: function () {
      this.$('.js-files-header').html(this.header_template(this.collection.params));
      return this;
    },

    renderList: function () {
      var files = [];

      this.files.collection.each(function (model) {
        var file = new FileItemView({model: model});
        files.push(file.$el);
      }, this);

      this.$('.js-files-list').html(files);
    },

    addFile: function (model) {
      var file = new FileItemView({
        model: model
      });
      this.collection.add(file.model);
      this.$('.js-files-list').prepend(file.$el);
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.remove();
      this.stopListening();
      return this;
    }

  });
  return View;
});

